module.exports = __webpack_public_path__ + "static/media/home-banner-2old.d2f40e44.png";